import React from 'react'

import "./Politicas.css"

const Politicas = () => {
  return (
<div className='layout-page politicas-page'>
      <h1>Política de Privacidad</h1>

      <section className="policy-section">
        <h2>Recopilación Mínima de Datos</h2>
        <p>
          Dado que la web no cuenta con pasarela de pagos ni comercio electrónico, la recopilación de datos se limita estrictamente a las interacciones voluntarias de los usuarios a través del formulario de contacto o consultas comerciales.
        </p>
      </section>

      <section className="policy-section">
        <h2>Uso de la Información</h2>
        <p>
          Los datos proporcionados (como nombre, correo electrónico o mensaje) se utilizan exclusivamente para:
        </p>
        <ul className="policy-list">
          <li>Responder a solicitudes de información, dudas sobre productos o consultas comerciales.</li>
          <li>Facilitar información sobre dónde encontrar tiendas aliadas o puntos de distribución autorizados.</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>Protección de Datos</h2>
        <p>
          Card Armory implementa medidas de seguridad razonables para proteger la información de contacto recibida. Los datos nunca son vendidos, alquilados ni compartidos con terceros con fines publicitarios o comerciales ajenos a la marca.
        </p>
      </section>

      <section className="policy-section">
        <h2>Uso de Cookies</h2>
        <p>
          El sitio web puede utilizar cookies técnicas y analíticas básicas para medir el tráfico y mejorar la experiencia de navegación, sin almacenar información de identificación personal sensible.
        </p>
      </section>

      <section className="policy-section">
        <h2>Derechos del Usuario</h2>
        <p>
          Los usuarios pueden solicitar en cualquier momento la revisión, actualización o eliminación de los datos personales que hayan proporcionado voluntariamente a través de nuestros canales de contacto.
        </p>
      </section>
    </div>
  )
}

export default Politicas